import { render, staticRenderFns } from "./Chinacom.vue?vue&type=template&id=6b9283d0&scoped=true"
import script from "./Chinacom.vue?vue&type=script&lang=js"
export * from "./Chinacom.vue?vue&type=script&lang=js"
import style0 from "./Chinacom.vue?vue&type=style&index=0&id=6b9283d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9283d0",
  null
  
)

export default component.exports